// Actions
export const SERVICE_HISTORY__GET_SCHEDULE = 'SERVICE_HISTORY__GET_SCHEDULE';
// Getters
export const SERVICE_HISTORY__FILTER_SCHEDULE_EVENT = 'SERVICE_HISTORY__FILTER_SCHEDULE_EVENT';
// Mutations
export const SERVICE_HISTORY__RESET = 'SERVICE_HISTORY__RESET';
export const SERVICE_HISTORY__MUTATE_SCHEDULE = 'SERVICE_HISTORY__MUTATE_SCHEDULE';
export const SERVICE_HISTORY__MUTATE_LOADING_STATUS = 'SERVICE_HISTORY__MUTATE_LOADING_STATUS';
